// How to use:
// 1) Attach v-bind="getNewFeatureTooltip(time, position)" to the html tag
// 2) The 'time' param is needed to know when you want this tooltip to expire. The format you want to follow is 'MM-DD'
// 3) The 'position' param is used to declare the direction of the tooltip
// 4) Use the 'isAlwaysVisible' param if you want to tooltip to always show. The default for this is to show only when hovered. For mobile, the tooltip is always be visible

import i18n from '@/i18n'
import moment from 'moment'
import breakpoints from '@/libs/breakpoints'

export default {
  methods: {
    getNewFeatureTooltip: function (time, position, isAlwaysVisible = false) {
      const thisYear = moment().year()
      const isVisible = moment().isBefore(`${thisYear}-${time}`)
      const isMobile = breakpoints.isMobile()

      if (isVisible) {
        const tooltip = {}
        tooltip['data-balloon'] = i18n.t('projectPage.new')
        tooltip['data-balloon-pos'] = position
        tooltip['data-balloon-visible'] = isMobile ? true : isAlwaysVisible
        return tooltip
      }
    }
  }
}
